import { render } from "./HeaderHome.vue?vue&type=template&id=f90dc9a2"
const script = {}

import "./HeaderHome.vue?vue&type=style&index=0&id=f90dc9a2&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__